































import { Component, Vue, Prop } from "vue-property-decorator";
import Fullscreen from "vue-fullscreen";
Vue.use(Fullscreen, { name: "fs" });
import { BIconArrowsFullscreen, BIconClock, BIconEye, BIconCircleFill } from "bootstrap-vue";
import { RevolvaService } from "@/service/revolva.service";
import * as actions from "@/service/revolva.action";
import * as actionsCustom from "@/service/revolva.action-custom";

interface Dictionary<T> {
  [Key: string]: T;
}
interface FullscreenComponent extends Element {
  getState(): boolean;
  toggle(): void;
}

@Component({
  components: {BIconArrowsFullscreen, BIconClock, BIconEye, BIconCircleFill},
})
export default class ToolBar extends Vue {
  @Prop() readonly revolva: RevolvaService | undefined;
  @Prop() readonly fullScreenToggle: Function | undefined;

  public animationToggle(){
      this.revolva.animation = !this.revolva.animation;
      actions.renderModel(this.revolva);
  }

  public setCadranColor()
  {
      this.revolva.cardranColor = this.revolva.cardranColor + 1;
       if(this.revolva.cardranColor === 4){
         this.revolva.cardranColor = 1;
       }
      if(this.revolva.cardranColor === 1){
        actionsCustom.changDial(this.revolva, 'black');
      }
      if(this.revolva.cardranColor === 3) {
        actionsCustom.changDial(this.revolva, 'grey');
      }
      if(this.revolva.cardranColor === 2) {
        actionsCustom.changDial(this.revolva, 'blue');
      }

      
      actions.renderModel(this.revolva);
  }
}
